import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=27ad0f28"
import script from "./Extras.vue?vue&type=script&lang=ts"
export * from "./Extras.vue?vue&type=script&lang=ts"
import style0 from "./Extras.vue?vue&type=style&index=0&id=27ad0f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports